import axios from 'axios'

export default function fetch(url, options = {}) {
  const token = localStorage.getItem('token') || '';
  const method = options.method || 'GET';
  const params = {
    url,
    method,
    headers: {
      'Authorization': token,
      'Content-Type': options.contentType || 'application/json'
    },
  };
  if (options.withoutToken) {
    delete params.headers.Authorization;
  }
  if (method === 'GET') {
    params.params = options.data || {};
  } else {
    params.data = options.data || {};
  }
  return new Promise((resolve, reject) => {
    axios(params).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err);
    });
  })
}
